import useProjectData from '@hooks/useProjectData';
import { ISettings } from '@store/services/projects/types';

const useProjectSettings = () => {
  const [{ settingsData, domains }, options] = useProjectData();
  return {
    settings: (settingsData ?? {}) as Partial<ISettings>,
    domains,
    ...options,
  };
};

export default useProjectSettings;
